import React, { useEffect, useState } from "react";
import {
  Row,
  Form,
  Col,
  DropdownButton,
  Dropdown as ReactDropdown,
  Container,
  Spinner,
  Image,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { AppDispatch, RootState } from "../../../redux/store";
import { getKeyPersonDetails } from "../redux/action/getKeyPersonDetails";
import { fetchIndividualDocs } from "../redux/action/fetchIndividualDocs";
import axios from "axios";
import { getSessionId, getUserRole } from "../../../utils/tokenHandlers";
import { getVerStatusKeyPerson } from "../redux/action/getVerStatusKeyPerson";
import VerStatusKeyPerson from "./verStatusKeyPerson";
import SectionHeading from "../../../components/common/SectionHeading";
import UidEmailRoleMatch from "../../constants/uidEmailRoleMatch";
import Button from "../../../components/common/Button";
import { SubmitHandler, useForm } from "react-hook-form";
import { BusinessDetailsType } from "../../opsUser/ppApplication/ppIndia/pages/types/BusinessDetailsType";
import { KeyPersonDetailsType } from "../../opsUser/ppApplication/ppIndia/pages/types/KeyPersonDetailsType";
import RadioButton from "../../../components/common/RadioButton";
import Input from "../../../components/common/Input";
import { updateKeyPerson } from "../../opsUser/ppApplication/ppIndia/apis/updateKeyPerson";
import { updateKeyPersonAction } from "../../opsUser/ppApplication/ppIndia/redux/action/updateKeyPersonAction";

const IndividualsSelection: React.FC = () => {
  const { appId } = useParams();
  const userRole = getUserRole();
  const dispatch = useDispatch<AppDispatch>();
  const customerId = Number(appId);
  const [docDataLoaded, setDocDataLoaded] = useState(false);
  const [selectedName, setSelectedName] = useState<string | null>(null);
  const [selectedId, setSelectedId] = useState(Number);
  const [selectedType, setSelectedType] = useState(" Select KYC Document");
  const [docType, setDocType] = useState("");
  const [docNameType, setDocNameType] = useState("");
  const [dataUpdated, setDataUpdated] = useState(false);
  const [SAClicked, setSAClicked] = useState(false);
  const [imageData, setImageData] = useState("");
  const [safId, SetSafId] = useState(Number);
  const [fileType, setFileType] = useState("");
  const [showSpinner, setShowSpinner] = useState(false);
  const [verDocId, setVerDocId] = useState(Number);
  const [makerVerStatus, setMakerVerStatus] = useState("");
  const [submitSpinner, setSubmitSpinner] = useState(false);
  const [checkerVerStatus, setCheckerVerStatus] = useState("");
  const [selectedDocIndex, setSelectedDocIndex] = useState<number | null>(null);
  const getAppSelector = useSelector(
    (state: RootState) => state.opsPpIndApp.getApp,
  );
  const appStage = getAppSelector.data.stage;
  const {
    register,
    handleSubmit,
    watch,
    reset,
    setValue,
    formState: { errors },
  } = useForm<KeyPersonDetailsType>({
    shouldUnregister: true,
  });

  const isCounterParty = getAppSelector.data.is_counterparty;
  const [docObjects, setDocObjects] = useState<
    {
      id: any;
      doc_type: string;
      doc_id: number;
      doc_name: string;
      doc_name_text: string;
      maker_status: string;
      checker_status: string;
    }[]
  >([]);
  const handleDropdownChange = async (
    selectedDocName: string,
    selectedDocType: string,
    selectedDocId: any,
  ) => {
    // setSelectedType("Select Document");
    setSAClicked(false);
    await fetchDocContent(selectedDocName, selectedDocType);
    const docObject = docObjects.find(
      (doc) =>
        doc.doc_name_text === selectedDocName &&
        doc.doc_type === selectedDocType &&
        doc.id === selectedDocId,
    );
    if (docObject) {
      // console.log("id::", selectedDocId);
      const docId = docObject.doc_id;
      setVerDocId(selectedDocId);
      setDocNameType(docObject.doc_name);
      const docTypee = docObject.doc_type;
      // // console.warn("boom---", docObject.doc_name);
      // console.warn("document id-->", docTypee);
      handleDocTypeSelect(docTypee);
      await handleVerStatusRemarks(selectedDocId);
    }
    // handleDocTypeSelect(selectedDocName);
    // await handleVerStatusRemarks();
  };
  const handleDocTypeSelect = (docType: string) => {
    setSelectedType(docType);
    localStorage.setItem("selectedType", docType);
    // console.warn("heres", localStorage.getItem("selectedType"));
  };
  useEffect(() => {
    const getKeyPersonNames = async () => {
      try {
        const result = await dispatch(getKeyPersonDetails(customerId));
        if (result.payload) {
          // console.warn("in main file-->", result.payload);
        } else {
          // console.warn("Something went wrong");
        }
      } catch (error) {
        // console.error("An error occurred", error);
      }
    };
    getKeyPersonNames();
  }, [customerId, dispatch]);
  useEffect(() => {
    const fetchDocsData = async () => {
      localStorage.removeItem("selectedType");
      if (selectedId !== null) {
        try {
          const result = await dispatch(
            fetchIndividualDocs({ customerId, selectedId }),
          );
          // console.log("here");
          if (result.payload) {
            if (result.payload.data?.result?.result[0]?.signed_digio_key_id) {
              SetSafId(
                result.payload.data?.result?.result[0]?.signed_digio_key_id,
              );
            }

            const documents =
              await result.payload.data.result.result[0]
                .customer_key_person_document_ids;
            const docObjects = documents.map(
              (document: {
                id: any;
                document_type: any;
                attachment_ids: any[];
                document_name: any;
                document_name_text: any;
                maker_verification_status: string;
                checker_verification_status: string;
              }) => ({
                id: document.id,
                doc_type: document.document_type,
                doc_id: document.attachment_ids,
                doc_name: document.document_name,
                doc_name_text: document.document_name_text,
                maker_status: document.maker_verification_status,
                checker_status: document.checker_verification_status,
              }),
            );
            setDocObjects(docObjects);
            // console.warn(`Doc obj for ${customerId} ${selectedId}`, docObjects);
          } else {
            // console.warn("Something went wrong!");
          }
          setDocDataLoaded(true);
        } catch (error) {
          // console.error("An error occured", error);
        }
      }
    };
    fetchDocsData();
  }, [customerId, dispatch, selectedId]);

  const handleSAFDocSubmit: SubmitHandler<KeyPersonDetailsType> = async (
    keyPersonDetails,
  ) => {
    // console.log(formData);
    setSubmitSpinner(true);
    const result = dispatch(
      updateKeyPersonAction({
        keyPersonId: Number(selectedId),
        keyPersonDetails,
      }),
    ).then(() => {
      // console.log(result);
      setSubmitSpinner(false);
      alert("Data updated!");
    });
  };

  const refreshVerificationStatus = async () => {
    const result = await dispatch(
      fetchIndividualDocs({ customerId, selectedId }),
    );
    if (result.payload) {
      const documents =
        result.payload.data.result.result[0].customer_key_person_document_ids;
      const updatedDocObjects = documents.map((document: any) => ({
        id: document.id,
        doc_type: document.document_type,
        doc_id: document.attachment_ids,
        doc_name: document.document_name,
        doc_name_text: document.document_name_text,
        maker_status: document.maker_verification_status,
        checker_status: document.checker_verification_status,
      }));
      setDocObjects(updatedDocObjects);
    }
  };

  const state = useSelector(
    (state: RootState) => state.verification.verIndividualDetails,
  );
  if (!state.data || !state.data.data) {
    return <Row>Loading...</Row>;
  }
  const individualStore: Array<{
    id: number;
    customer_id: string;
    first_name: string;
    middle_name: string;
    last_name: string;
    signed_digio_key_id: number;
    // key_person_saf_maker_verification_status: string;
    // key_person_saf_maker_verification_comments: string;
    // key_person_saf_checker_verification_status: string;
    // key_person_saf_checker_verification_comments: string;
  }> = state.data.data.result.result;
  const sessionId = getSessionId();
  const fetchDocContent = async (
    selectedDocName: string,
    selectedDocType: string,
  ) => {
    setDataUpdated(false);
    setShowSpinner(true);

    const docObject = docObjects.find(
      (doc) =>
        doc.doc_name_text === selectedDocName &&
        doc.doc_type === selectedDocType,
    );

    if (docObject) {
      const docId = docObject.doc_id;
      setDocNameType(docObject.doc_name);

      const apiUrl = `${process.env.REACT_APP_BASE_URL}web/read/content/${docId}`;
      const headers = {
        Authorization: `Bearer ${sessionId}`,
      };
      try {
        const response = await axios.post(
          apiUrl,
          { params: { ...UidEmailRoleMatch() } },
          { headers },
        );

        const fileString: string = response.data.result;

        if (fileString.startsWith("%PDF")) {
          // Convert string → binary array (safe for older TS targets)
          const byteArray = new Uint8Array(fileString.length);
          for (let i = 0; i < fileString.length; i++) {
            byteArray[i] = fileString.charCodeAt(i);
          }

          const blob = new Blob([byteArray], { type: "application/pdf" });
          const blobUrl = URL.createObjectURL(blob);
          setImageData(blobUrl);
          setFileType("pdf");
        } else {
          const base64Data = btoa(fileString);
          const imageBase64 = `data:image/png;base64,${base64Data}`;
          setImageData(imageBase64);
          setFileType("img");
        }
      } catch (error) {
        // Handle error
        setShowSpinner(false);
      }
    }

    setShowSpinner(false);
  };

  const handleSelectChange = async (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    setSelectedType("Select KYC Document");
    setSAClicked(false);
    setDocDataLoaded(false);
    setImageData("");
    const value = event.target.value;
    setSelectedName(value);
    if (value) {
      const selectedIndividual = individualStore.find(
        (individual) =>
          `${individual.first_name} ${individual.last_name}` === value,
      );
      if (selectedIndividual) {
        const selectedId = selectedIndividual.id;
        setSelectedId(selectedId);
        console.log(selectedIndividual);

        // if (selectedIndividual.key_person_saf_maker_verification_status) {
        //   setTimeout(() => {
        //     setValue(
        //       "key_person_saf_maker_verification_status",
        //       selectedIndividual.key_person_saf_maker_verification_status,
        //     );
        //     setValue(
        //       "key_person_saf_maker_verification_comments",
        //       selectedIndividual.key_person_saf_maker_verification_comments,
        //     );
        //     setValue(
        //       "key_person_saf_checker_verification_status",
        //       selectedIndividual.key_person_saf_checker_verification_status,
        //     );
        //     setValue(
        //       "key_person_saf_checker_verification_comments",
        //       selectedIndividual.key_person_saf_checker_verification_comments,
        //     );
        //   }, 2000);

        //   // console.log(
        //   //   selectedIndividual.key_person_saf_maker_verification_status,
        //   // );
        //   // ({
        //   //   key_person_saf_maker_verification_status:
        //   //     selectedIndividual.key_person_saf_maker_verification_status,
        //   //   key_person_saf_maker_verification_comments:
        //   //     selectedIndividual.key_person_saf_maker_verification_comments,
        //   //   key_person_saf_checker_verification_status:
        //   //     selectedIndividual.key_person_saf_checker_verification_status,
        //   //   key_person_saf_checker_verification_comments:
        //   //     selectedIndividual.key_person_saf_checker_verification_comments,
        //   // });
        // }

        // console.log("selected id:", selectedId);
        // console.log("Selected Name:", value);
        // if (selectedId) {
        //   // console.log("SelectdeId--", selectedId);
        //   // await fetchDocsData();
        // } else {
        //   // console.warn("hello");
        // }
      }
    }
  };

  const handleSignedAppClick = async () => {
    setSAClicked(true);
    setDataUpdated(false);
    setSelectedType("Select KYC Document");
    // console.log(safId);
    if (safId) {
      // setShowSpinner(true);

      let docId = safId;
      const apiUrl = `${process.env.REACT_APP_BASE_URL}web/read/content/${docId}`;
      const headers = {
        Authorization: `Bearer ${sessionId}`,
      };
      try {
        const response = await axios.post(
          apiUrl,
          { params: { ...UidEmailRoleMatch() } },
          { headers },
        );
        const fileString: string = response.data.result;

        if (fileString.startsWith("%PDF")) {
          // Convert string → binary array (safe for older TS targets)
          const byteArray = new Uint8Array(fileString.length);
          for (let i = 0; i < fileString.length; i++) {
            byteArray[i] = fileString.charCodeAt(i);
          }

          const blob = new Blob([byteArray], { type: "application/pdf" });
          const blobUrl = URL.createObjectURL(blob);
          setImageData(blobUrl);
          setFileType("pdf");
        } else {
          const base64Data = btoa(fileString);
          const imageBase64 = `data:image/png;base64,${base64Data}`;
          setImageData(imageBase64);
          setFileType("img");
        }
      } catch (error) {
        // Handle error
        setShowSpinner(false);
      }
    } else {
      alert("Signed Form is not uploaded!");
    }
  };

  const handleVerStatusRemarks = async (selectedDocId: any) => {
    try {
      const result = await dispatch(
        getVerStatusKeyPerson({ selectedId, selectedDocId }),
      );
      if (result.payload) {
        // console.log("in main file--", result.payload);
        setTimeout(() => {
          setDataUpdated(true);
        }, 500);
      }
    } catch (error) {
      // console.error("An error occured", error);
    }
  };
  return (
    <>
      {isCounterParty === false && (
        <Form>
          <Form.Select value={selectedName || ""} onChange={handleSelectChange}>
            <option value="">Select an Individual</option>
            {individualStore.map((individual) => (
              <option
                key={individual.id}
                value={`${individual.first_name} ${individual.last_name}`}
              >
                {`${individual.first_name} ${individual.last_name} `}
              </option>
            ))}
          </Form.Select>
        </Form>
      )}
      <Row className="mt-3">
        <>
          {isCounterParty === false && (
            <>
              <Col md={6}>
                {docDataLoaded ? ( // Render the document type dropdown only when data is loaded
                  <DropdownButton
                    id="document-type-dropdown"
                    title={selectedType}
                    variant="outline-primary"
                    style={{
                      marginLeft: "15px",
                    }}
                  >
                    {[...docObjects]
                      .sort((a, b) => a.doc_type.localeCompare(b.doc_type))
                      .map((docObject) => {
                        const { maker_status, checker_status } = docObject;

                        let textColor = "";
                        if (maker_status === "Failure") {
                          textColor = "#ca7373ff";
                        } else if (maker_status === "Success") {
                          textColor = "#C2FFC7";
                        }
                        return (
                          <ReactDropdown.Item
                            key={docObject.doc_id}
                            onClick={() => {
                              setDocType(docObject.doc_type);
                              handleDropdownChange(
                                docObject.doc_name_text,
                                docObject.doc_type,
                                docObject.id,
                              );
                            }}
                            style={{ backgroundColor: textColor }}
                          >
                            {docObject.doc_type} - {docObject.doc_name} -{" "}
                            {docObject.doc_name_text}
                          </ReactDropdown.Item>
                        );
                      })}
                  </DropdownButton>
                ) : (
                  // Render a loading spinner while data is being fetched
                  <>
                    {isCounterParty === true ? (
                      <p className="mt-3" style={{ color: "#d64161" }}>
                        KYC IS NOT APPLICABLE FOR COUNTERPARTY APPLICATIONS...
                      </p>
                    ) : (
                      // <SectionHeading text="KYC IS NOT APPLICABLE FOR COUNTERPARTY APPLICATIONS..." />
                      <>
                        {/* <p>Select an Individual</p> */}
                        {/* {// console.log("isCounterParty is not true:", isCounterParty)} */}
                      </>
                    )}
                  </>
                  // "Select an Individual"
                )}
              </Col>
              {/*  */}
              {docDataLoaded && (
                <Col className="text-center">
                  <Button
                    label="View Signed Application"
                    variant="outline-primary"
                    onClick={handleSignedAppClick}
                  />
                </Col>
              )}
            </>
          )}
        </>
      </Row>
      <Row className="mt-4">
        <Col md={6}>
          {imageData && (
            <Container>
              {showSpinner ? (
                <Spinner variant="primary" animation="border" />
              ) : fileType === "pdf" ? (
                <iframe
                  src={imageData}
                  title="Document viewer"
                  style={{ width: "550px", height: "550px" }}
                />
              ) : fileType === "img" ? (
                <Image
                  src={imageData}
                  style={{ width: "550px", border: "solid" }}
                />
              ) : null}
            </Container>
          )}
        </Col>
      </Row>

      {/* <Form onSubmit={handleSubmit(handleSAFDocSubmit)}>
        {SAClicked && (
          <>
            <Row>
              <Col md="12">
                <SectionHeading text="Document Verification: SAF" />
              </Col>
            </Row>
            <Row>
              <RadioButton
                name={"key_person_saf_maker_verification_status"}
                label={"Maker Verification Status"}
                options={[
                  { label: "Success", value: "Success" },
                  { label: "Failure", value: "Failure" },
                ]}
                register={register}
                // error={errors.mk_master_agreeement_attachment_status?.message}
                // required={userRole == "maker"}
                // requiredMessage="Verification Status is required"
                disabled={userRole !== "maker"}
                onChange={(e) => setMakerVerStatus(e.target.value)}
              />
            </Row>
            <Row>
              <Input
                label="Maker Verification Remarks"
                name="key_person_saf_maker_verification_comments"
                register={register}
                required={userRole == "maker" && makerVerStatus == "Failure"}
                requiredMessage="Verification Remark is required"
                error={
                  errors.key_person_saf_maker_verification_comments?.message
                }
                disabled={userRole !== "maker"}
                placeholder="Enter maker verification remarks"
              />
            </Row>
            <Row>
              <RadioButton
                name={"key_person_saf_checker_verification_status"}
                label={"Checker Verification Status"}
                options={[
                  { label: "Success", value: "Success" },
                  { label: "Failure", value: "Failure" },
                ]}
                register={register}
                error={
                  errors.key_person_saf_checker_verification_status?.message
                }
                required={userRole !== "maker"}
                requiredMessage="Verification Status is required"
                disabled={
                  userRole === "maker" || appStage !== "In Checker Verification"
                }
                onChange={(e) => setCheckerVerStatus(e.target.value)}
              />
            </Row>
            <Row>
              <Input
                label="Checker Verification Remarks"
                name="key_person_saf_checker_verification_comments"
                register={register}
                required={userRole !== "maker" && checkerVerStatus == "Failure"}
                // requiredMessage="Verification Remark is required"
                error={
                  errors.key_person_saf_checker_verification_comments?.message
                }
                disabled={
                  userRole === "maker" || appStage !== "In Checker Verification"
                }
                placeholder="Enter checker verification remarks"
              />
            </Row>
          </>
        )}
        <Row className="mt-2">
          {(appStage == "In Maker Verification" ||
            appStage == "In Checker Verification") && (
            <Col className="text-end">
              {SAClicked &&
                (submitSpinner ? (
                  <Spinner variant="primary" animation="border" />
                ) : (
                  <Button
                    type="submit"
                    label="Save Details"
                    disabled={
                      appStage === "Expired" ||
                      appStage === "Customer Registered" ||
                      appStage === "In Customer Registration" ||
                      (appStage == "In Checker Verification" &&
                        userRole == "maker") ||
                      (appStage == "In Maker Verification" &&
                        userRole == "checker")
                    }
                  />
                ))}
            </Col>
          )}
        </Row>
      </Form> */}

      {dataUpdated && imageData ? (
        <VerStatusKeyPerson
          selectedDocType={selectedType}
          verDocId={verDocId}
          onRefresh={refreshVerificationStatus}
        />
      ) : null}
    </>
  );
};
export default IndividualsSelection;
